import React from "react";

export default function NoPage() {
	return (
		<div className="container p-5">
			<h5>Sayfa bulunamadı.</h5>
		</div>
	);
}
